import { FaEdit, FaListUl, FaTrash, FaEye, FaArrowRight } from "react-icons/fa";
import { getShortDescription, getDomainImageUrl, handleImageError } from "../../service/utils/domainUtils";
import { formatDate } from '../../service/utils/formatters';


/**
 * CARTE DE DOMAINE - Affiche une carte élégante pour chaque domaine
 * @param {Object} props
 * @param {Object} props.domain - Données du domaine
 * @param {number} props.managerCount - Nombre de managers
 * @param {Function} props.onEdit - Callback pour éditer
 * @param {Function} props.onDelete - Callback pour supprimer
 * @param {Function} props.onViewManagers - Callback pour voir les managers
 * @param {Function} props.onViewDetails - Callback pour voir les détails
 * @param {Function} props.onEnterDomain - Callback pour entrer dans le domaine
 */
const DomainCard = ({ 
  domain, 
  managerCount, 
  onEdit, 
  onDelete, 
  onViewManagers, 
  onViewDetails, 
  onEnterDomain 
}) => {
  return (
    <div className="col-xl-4 col-md-6 mb-4">
      <div className="card domain-card h-100 shadow-sm border-0 rounded-3 overflow-hidden">
        
        {/* En-tête avec image et menu */}
        <div className="card-header position-relative p-0 border-0">
          {/* Image du domaine */}
          <div className="domain-image-container">
            <img
              src={getDomainImageUrl(domain.photo)}
              alt={domain.name}
              className="domain-image"
              onError={handleImageError}
            />
          </div>
          
          {/* Badge du nom */}
          <div className="domain-badge">
            <span className="badge bg-primary text-white px-3 py-2 rounded-pill">
              {domain.name}
            </span>
          </div>

          {/* Menu d'actions */}
          <div className="domain-actions">
            <div className="dropdown">
              <button
                className="btn btn-primary btn-sm rounded-circle p-2 shadow"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                  <path d="M8.333 10a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z" fill="#ffffff"/>
                  <path d="M8.333 3.333a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z" fill="#ffffff"/>
                  <path d="M8.333 16.667a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z" fill="#ffffff"/>
                </svg>
              </button>

              <ul className="dropdown-menu dropdown-menu-end shadow border-0 rounded-2 py-2">
                <li>
                  <button 
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => onViewManagers(domain)}
                  >
                    <FaListUl className="me-2" size={14} />
                    Liste des Gestionnaires
                  </button>
                </li>
                <li>
                  <button 
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => onEdit(domain)}
                  >
                    <FaEdit className="me-2" size={14} />
                    Modifier
                  </button>
                </li>
                <li>
                  <button 
                    className="dropdown-item d-flex align-items-center text-danger"
                    onClick={() => onDelete(domain.id)}
                  >
                    <FaTrash className="me-2" size={12} />
                    Supprimer
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Corps de la carte */}
        <div className="card-body p-4">
          {/* Informations principales */}
          <div className="domain-info mb-3">
            <h6 className="domain-name mb-2 fw-bold text-dark">{domain.name}</h6>
            <p className="domain-email mb-2">
              <a href={`mailto:${domain.email}`} className="text-primary text-decoration-none">
                {domain.email}
              </a>
            </p>
            <div className="domain-meta d-flex justify-content-between text-muted small">
              <span>Créé le : {formatDate(domain.creationDate)}</span>
              <span className="fw-semibold">
                <span className="text-primary">{managerCount}</span> gestionnaire{managerCount !== 1 ? 's' : ''}
              </span>
            </div>
          </div>

          {/* Description */}
          <div className="domain-description">
            <p className="text-muted small mb-0">
              {getShortDescription(domain.description)}
            </p>
          </div>
        </div>

        {/* Pied de carte avec actions */}
        <div className="card-footer bg-transparent border-0 pt-0">
          <div className="d-flex justify-content-between align-items-center">
            {/* Bouton Voir détails */}
            <button
              className="btn btn-outline-primary btn-sm d-flex align-items-center"
              onClick={() => onViewDetails(domain)}
            >
              <FaEye className="me-1" size={12} />
              Détails
            </button>

            {/* Bouton Entrer */}
            <button
              className="btn btn-primary btn-sm d-flex align-items-center shadow"
              onClick={(e) => onEnterDomain(e, domain)}
            >
              Entrer
              <FaArrowRight className="ms-1" size={12} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DomainCard;